import { ISkillBlockResource } from "@sol/sdk/skill-blocks";
import { ISkillDomainResource } from "@sol/sdk/skill-domains";
import { mapRelationalFilter, RelationalFilter } from "@sol/sdk/utils";

import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { serialize } from "../../utils/url";
import { IBadgeList } from "../types";

export interface IBadgeListQueryParameters extends IPaginateable, IOrderable<"name" | "createdAt"> {
    filters?: {
        name?: string;
        skillGroup?: RelationalFilter<ISkillDomainResource | ISkillBlockResource>;
        existsInSkillDomain?: boolean;
        existsInSkillBlock?: boolean;
    };
}

export type IBadgeListQueryResult = IBadgeList;

const mapFilters = (filters: IBadgeListQueryParameters["filters"]) => {
    const { name, skillGroup, existsInSkillDomain, existsInSkillBlock } = filters ?? {};
    return {
        name,
        skillGroup: mapRelationalFilter(skillGroup),
        "exists[skillDomain]": existsInSkillDomain,
        "exists[skillBlock]": existsInSkillBlock,
    };
};

export const badgeListQuery: IApiQueryFunction<IBadgeListQueryParameters> = ({ filters, pagination, order }) => {
    return {
        method: "GET",
        url: `/badges${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useBadgeListQuery = createApiQueryHook<IBadgeListQueryParameters, IBadgeListQueryResult>(badgeListQuery);
